/**
 * @generated SignedSource<<077a661697424e13ae45a28a21982ec2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
export type EventCapacityType = "ATTENDEES" | "GROUPS";
import { FragmentRefs } from "relay-runtime";
export type EventDetailBody$data = {
  readonly allowedGroupSizes: ReadonlyArray<number | null | undefined>;
  readonly capacity: number | null | undefined;
  readonly capacityType: EventCapacityType | null | undefined;
  readonly description: string | null | undefined;
  readonly eventSeries: {
    readonly color: CustomColor;
    readonly image: {
      readonly publicId: string;
    } | null | undefined;
    readonly published: boolean;
  };
  readonly eventSessions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"EventDetailHosts" | "EventDetailInfo_eventSession">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly eventSignUps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly registrations: {
          readonly count: number;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"EventDetailAttendeesGroupListItemFragment" | "EventDetailAttendeesListItemFragment">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly maxGuestCount: number;
  readonly maxMemberCount: number;
  readonly minGuestCount: number;
  readonly minMemberCount: number;
  readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
  readonly spotsAvailable: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailAttendeesList" | "EventDetailGroupDisplay_event" | "EventDetailMultiSessionEventDisplay_event" | "EventDetailPairings_event" | "EventDetailSeriesInfo_event">;
  readonly " $fragmentType": "EventDetailBody";
};
export type EventDetailBody$key = {
  readonly " $data"?: EventDetailBody$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailBody">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailBody",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailAttendeesList"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailGroupDisplay_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailMultiSessionEventDisplay_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailSeriesInfo_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetailPairings_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "clientId",
          "variableName": "memberId"
        }
      ],
      "kind": "ScalarField",
      "name": "signUpStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "EventSessionConnection",
      "kind": "LinkedField",
      "name": "eventSessions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSession",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDetailHosts"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDetailInfo_eventSession"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "eventSessions(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowedGroupSizes",
      "storageKey": null
    },
    {
      "alias": "eventSignUps",
      "args": [
        {
          "kind": "Literal",
          "name": "waitlist",
          "value": false
        }
      ],
      "concreteType": "EventSignUpConnection",
      "kind": "LinkedField",
      "name": "signUps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationConnection",
                  "kind": "LinkedField",
                  "name": "registrations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDetailAttendeesListItemFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDetailAttendeesGroupListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "signUps(waitlist:false)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": "publicId",
              "args": null,
              "kind": "ScalarField",
              "name": "renderingKey",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "published",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "7b76f47c22510d545482fae52aeff3de";

export default node;
